<div class="card p-3">
  <header class="sub-header mb-3">
    <ng-container *ngIf="heading; else addRole">
      <h5>Navigation Tree</h5>
    </ng-container>
    <ng-template #addRole>
      <h5>Add Module Mapping</h5>
    </ng-template>
  </header>
  <form [formGroup]="form" (ngSubmit)="onUserSubmit(form.value)">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-sm-12">
        <mat-form-field class="w-100" appearance="outline">
          <mat-select [disabled]=SavedRoles placeholder="Roles" name="Parent" formControlName="roleId">
            <mat-select-search autocomplete="off" placeholder="Search Roles" [formControl]="RoleListCtrl">
            </mat-select-search>
            <mat-option *ngFor="let mile of this.roles" [value]="mile.id" (onSelectionChange)="parentselect($event)">
              {{mile.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('roleId')?.hasError('required')">
            Role is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-12">
        <mat-form-field class="w-100" appearance="outline">
          <input matInput autocomplete="off" placeholder="Search Navigation Links" [formControl]="LinkListCtrl">
        </mat-form-field>
      </div>
    </div>
  </form>
  <hr />
  <div class="row">
    <!-- <ng-container *ngFor="let mile of data; let i = index">
          <div class="col-md-6 col-lg-6 col-sm-12 mb-3">
            <div class="card shadow-sm border rounded p-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="mile.isAdmin"
                    [disabled]="mile.isDisabled"
                    [ngModelOptions]="{ standalone: true }"
                    (click)="getCheckedValue($event, mile)"
                  />
                  <label class="form-check-label fw-bold">{{ mile.title }}</label>
                </div>
              
                <div>                
                  <input
                  type="number"
                  placeholder="Order no."
                  class="order-no filled-input"
                  [(ngModel)]="mile.orderNo"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="onOrderChange(mile)"
                  [disabled]="!mile.isAdmin"  
                  required              
                  />

                </div>
              
                <small class="text-muted">[{{ mile?.parentName || '-' }}]</small>
              </div>
              
      
              <div class="d-flex flex-wrap gap-2">
                <ng-container *ngFor="let permission of mile.access; let j = index">
                  <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" [id]="'perm_' + j + '_' + permission"
                      [checked]="mile?.access1?.includes(permission)"
                      (change)="onPermissionChange($event, mile, permission)" />
                    <label class="form-check-label" [for]="'perm_' + j + '_' + permission">
                      {{ permission }}
                    </label>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container> -->
    <!-- <mat-accordion>
          <mat-expansion-panel
            *ngFor="let mile of hierarchicalData; let i = index"
            [expanded]="mile.isExpanded"
            [disabled]="!mile.children || mile.children.length === 0"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  [(ngModel)]="mile.isAdmin"
                  [disabled]="mile.isDisabled"
                  (change)="onAdminChange(mile)"
                />
                {{ mile.linkName }}
                <input
                  type="number"
                  class="ms-3"
                  placeholder="Order No."
                  [(ngModel)]="mile.linkOrder"
                  [disabled]="!mile.isAdmin"
                  (change)="onOrderChange(mile)"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
        
            <div class="child-links px-3 pt-2 pb-3" *ngIf="mile.children && mile.children.length > 0">
              <div
                *ngFor="let child of mile.children"
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <div>
                  <input
                    type="checkbox"
                    [(ngModel)]="child.isAdmin"
                    [disabled]="child.isDisabled"
                    (change)="onChildAdminChange(child)"
                  />
                  {{ child.title }}
                </div>
        
                <input
                  type="number"
                  placeholder="Order No."
                  class="ms-3"
                  [(ngModel)]="child.linkOrder"
                  [disabled]="!child.isAdmin"
                  (change)="onOrderChange(child)"
                />
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion> -->

    <div class="col-md-7 col-lg-7">
      <h5 class="header-rolemap">Nav Link With Parent</h5>
      <hr class="header-rolemap-hr"/>
      <ng-container *ngFor="let mile of hierarchicalData; let i = index">
        <div *ngIf="mile.linkName && mile.children.length > 0">
          <mat-accordion class="navigation-mapping">
            <mat-expansion-panel *ngIf="mile.children && mile.children.length > 0" [expanded]="mile.isExpanded">
              <mat-expansion-panel-header>
                <mat-panel-title class="gap-2">
                  <input type="checkbox" [(ngModel)]="mile.isAdmin" 
                    (change)="getCheckedValue($event, mile)" (click)="$event.stopPropagation()" class="checkbox-1" />
                  <span class="mapping-name">{{ mile.linkName }}</span>
                  <input type="number" class="ms-3" placeholder="Order" [(ngModel)]="mile.orderNo"
                    (change)="onOrderChange($event,mile)" (click)="$event.stopPropagation()"
                    class="mapping-number form-control" />
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="child-links px-3 pt-2 pb-3">
                <div *ngFor="let child of mile.children" class="main-child-mapping mb-2">
                  <div class="child-mapping-flex">
                    <input type="checkbox" [(ngModel)]="child.isAdmin"
                       (change)="getCheckedValue($event, mile.children)"
                      (click)="$event.stopPropagation()" class="checkbox-1" />
                    <span class="mapping-name-child mapping-name">{{ child.title }}</span>
                  </div>
                  <p class="text-muted mapping-linked-name">[{{ mile?.linkName || '-' }}]</p>
                  <input type="number" placeholder="Order" class="mapping-number form-control"
                    [(ngModel)]="child.orderNo" (change)="getChildOrder(child,mile)"
                    (click)="$event.stopPropagation()" />

                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </ng-container>
    </div>
    <div class="col-md-5 col-lg-5">
      <h5 class="header-rolemap">Nav Link Without Parent</h5>
      <hr class="header-rolemap-hr"/>
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 col-12" *ngFor="let mile of hierarchicalData; let i = index">
          <div class="without-link mb-2 navigation-mapping" *ngIf="!mile.linkName">
            <div class="flex-check-title">
              <input type="checkbox" [(ngModel)]="mile.isAdmin"
              (change)="getCheckedValue($event, mile)" (click)="$event.stopPropagation()"/>
            <span class="ms-2">{{ mile.title }}</span>
            </div>
            <input type="number" placeholder="Order" (change)="onOrderChange($event,mile)"
              [(ngModel)]="mile.orderNo" (click)="$event.stopPropagation()" class="form-control number-text"/>
            <!-- <p class="mapping-linked-name">[{{ mile?.parentName || '-' }}]</p> -->
          </div>
        </div>
      </div>
        <!-- <div *ngFor="let mile of hierarchicalData; let i = index">
          <div class="without-link mb-2 ps-3 navigation-mapping" *ngIf="!mile.linkName">
            <div class="">
              <input type="checkbox" [(ngModel)]="mile.isAdmin" [disabled]="!mile.orderNo"
              (change)="getCheckedValue($event, mile)" (click)="$event.stopPropagation()" class="checkbox-1"/>
            <span class="mapping-name">{{ mile.title }}</span>
            </div>
            <input type="number" placeholder="Link Order No." (change)="onOrderChange($event,mile)"
              [(ngModel)]="mile.orderNo" (click)="$event.stopPropagation()" class="mapping-number-1 form-control"/>
            <p class="mapping-linked-name">[{{ mile?.parentName || '-' }}]</p>
          </div>
        </div> -->
    </div>
    <!-- Standalone links (no parent) -->

    <div *ngIf="data.length === 0" class="col-md-12">
      <div class="alert alert-warning text-center">No Data Found...</div>
    </div>
  </div>
  <div class="button-container">
    <button type="submit" (click)="onUserSubmit(form.value)" class="btn btn-save btn-icon-text mb-2 mb-md-0 me-2">
      <mat-icon>save</mat-icon>
      <span *ngIf="!common.navLinkRoleId">Save</span><span *ngIf="common.navLinkRoleId">Update</span>
    </button>
    <button class="btn btn-cancel btn-icon-text mb-2 mb-md-0" (click)="closeDialog()">
      <mat-icon>close</mat-icon>Cancel
    </button>
  </div>
</div>